import Tooltip from '@material-ui/core/Tooltip';

import { startCase } from 'lodash';

import moment from 'moment';

import { headerStyle } from 'containers/App/constants';

import { getDocumentStatus } from './status';

const requestsColumns = [];

const abbreviationToName = {
	ROI: 'Release of Information',
	Rx: 'Rx',
	LEAVE: 'Leave of Absence',
	DISCONTINUANCE: 'Discontinuance',
	'Patient-Intake': 'Patient Intake',
	'Intake-Questionnaire': 'Intake Questionnaire',
	'ENROLLMENT-REQUEST': 'Enrollment Request',
	Telehealth: 'Telehealth',
};

const sanitizeName = (data) => {
	const { documentType, filename } = data;
	if (documentType === 'FORM-SHARE') {
		return filename;
	}

	return startCase(abbreviationToName[documentType]);
};

const badgeClasses = {
	success: 'badge-success',
	danger: 'badge-danger',
	warning: 'badge-warning',
	neutral: 'badge-secondary',
};

const renderStatus = (row) => {
	const { label, variant, tooltip } = getDocumentStatus(row);
	const badge = (
		<span
			className={`badge ${badgeClasses[variant]} font-10 px-2 py-1 text-uppercase`}
		>
			{label}
		</span>
	);

	return (
		<div className="mt-2 mx-2">
			{tooltip ? <Tooltip title={tooltip}>{badge}</Tooltip> : badge}
		</div>
	);
};

// Both tables share one column set; `type` only affects the TYPE cell (the
// completed table's name is a link that opens the form). The pending-only
// REQUESTOR column was removed 2026-09-03: a document only lands in Pending when
// it has no request state, so the request sender it displayed was always empty.
const getDocsColumns = (type, viewForm) => {
	const columns = [
		{
			field: 'documentType',
			title: 'TYPE',
			headerStyle,
			headerClasses: 'table-header font-10 text-uppercase',
			render: (row) => (
				<div
					className={`mt-2 mx-2 font-13 hand ${
						type === 'pending' ? '' : 'link-color'
					}`}
					onClick={() => type !== 'pending' && viewForm(row)}
				>
					{sanitizeName(row)}
				</div>
			),
		},
		{
			field: 'status',
			title: 'STATUS',
			headerStyle,
			headerClasses: 'table-header font-10 text-uppercase',
			render: renderStatus,
		},
		{
			field: 'createdAt',
			title: 'CREATED AT',
			headerStyle,
			headerClasses: 'table-header font-10 text-uppercase',
			render: (row) => (
				<div className="mt-2 mx-2 font-13">
					{moment(row.createdAt).format('MMM D, YYYY') || '-'}
				</div>
			),
		},
		{
			field: 'updatedAt',
			title: 'UPDATED AT',
			headerStyle,
			headerClasses: 'table-header font-10 text-uppercase',
			render: (row) => (
				<div className="mt-2 mx-2 font-13">
					{moment(row.updatedAt).format('MMM D, YYYY') !==
						moment(row.createdAt).format('MMM D, YYYY')
						? moment(row.updatedAt).format('MMM D, YYYY')
						: '-'}
				</div>
			),
		},
	];

	return columns;
};

export { requestsColumns, getDocsColumns };
